import {
    FETCH_CITAS_REQUEST,
    FETCH_CITAS_SUCCESS,
    FETCH_CITAS_FAILURE,
    CREATE_CITA_REQUEST,
    CREATE_CITA_SUCCESS,
    CREATE_CITA_FAILURE,
    UPDATE_CITA_REQUEST,
    UPDATE_CITA_SUCCESS,
    UPDATE_CITA_FAILURE,
    DELETE_CITA_REQUEST,
    DELETE_CITA_SUCCESS,
    DELETE_CITA_FAILURE,
    CREATE_CITA_WARNING
} from "../../../constants/citas/citas";
import { CitaState } from "../../../types/citas/Citas";

const INIT_STATE: CitaState = {
    rex_citas: [],
    rex_success: false,
    rex_error: null,
    rex_loading: false,
    rex_tipo: ""
};

export default (state = INIT_STATE, action: any): CitaState => {
    switch (action.type) {
        case FETCH_CITAS_REQUEST:
            return {
                ...state,
                rex_loading: true,
                rex_error: null
            };
        case FETCH_CITAS_SUCCESS:
            return {
                ...state,
                rex_loading: false,
                rex_citas: action.payload.data
            };
        case FETCH_CITAS_FAILURE:
            return {
                ...state,
                rex_loading: false,
                rex_error: action.payload
            };

        case CREATE_CITA_REQUEST:
            return {
                ...state,
                rex_loading: true,
                rex_success: false,
                rex_error: null
            };

        case CREATE_CITA_SUCCESS:
            return {
                ...state,
                rex_loading: false,
                rex_success: true,
                rex_tipo: action.payload.tipo,
                rex_citas: [...state.rex_citas, action.payload.cita]
            };

        case CREATE_CITA_FAILURE:
            return {
                ...state,
                rex_loading: false,
                rex_success: false,
                rex_error: action.payload
            };
        case UPDATE_CITA_REQUEST:
            return {
                ...state,
                rex_loading: true,
                rex_success: false,
                rex_error: null
            };
        case UPDATE_CITA_SUCCESS:
            const updatedCitas = state.rex_citas.map(cita =>
                cita.id === action.payload.cita.id
                    ? action.payload.cita
                    : cita
            );

            return {
                ...state,
                rex_loading: false,
                rex_success: true,
                rex_citas: updatedCitas
            };

        case UPDATE_CITA_FAILURE:
            return {
                ...state,
                rex_loading: false,
                rex_success: false,
                rex_error: action.payload
            };

        case DELETE_CITA_REQUEST:
            return {
                ...state,
                rex_loading: true,
                rex_error: null
            };

        case DELETE_CITA_SUCCESS:
            const filteredUsuarios = state.rex_citas.filter(
                cita => String(cita.id) !== String(action.payload)
            );
            return {
                ...state,
                rex_loading: false,
                rex_citas: filteredUsuarios
            };

        case DELETE_CITA_FAILURE:
            return {
                ...state,
                rex_loading: false,
                rex_success: action.payload
            };
        case CREATE_CITA_WARNING:
            console.log('action:', action.payload)
            return {
                ...state,
                rex_loading: false,
                rex_success: true,
                rex_tipo: action.payload.tipo,
                // rex_citas: [...state.rex_citas, action.payload.cita]
            };
        default:
            return state;
    }
};